import { GetCashboxCategoriesSuccessAction } from "./action";
import { CREATE_INCOME_RECORD_API, CREATE_INCOME_RECORD_API_ERROR, CREATE_INCOME_RECORD_API_SUCCESS, GET_CASHBOX_CATEGORIES_API, GET_CASHBOX_CATEGORIES_API_ERROR, GET_CASHBOX_CATEGORIES_API_SUCCESS, GET_INCOME_RECORDS_API, GET_INCOME_RECORDS_API_ERROR, GET_INCOME_RECORDS_API_SUCCESS, UPSERT_CASHBOX_CATEGORY_API, UPSERT_CASHBOX_CATEGORY_API_ERROR, UPSERT_CASHBOX_CATEGORY_API_SUCCESS } from "./actionTypes";
import { CashboxError, CashboxErrorOrigin } from "./types";
import { parseDataKey } from "src/common/util";
import { ErrorAction } from "src/common/apiLoader/state/actions";
import { CashboxCategory } from "src/common/models/cashboxCategory";
import { IncomeRecord } from "src/common/models/incomeRecord";

export interface CashboxState {
    cashboxCategories?: CashboxCategory[]
    error: CashboxError | undefined
    upsertCashboxCategorySuccess: boolean
    createIncomeRecordSuccess: boolean
    incomeRecords?: IncomeRecord[]
}

const initialState: CashboxState = {
    error: undefined,
    upsertCashboxCategorySuccess: false,
    createIncomeRecordSuccess: false,
}

const cashboxReducer = (state: CashboxState = initialState, action: any): CashboxState => {
    switch (action.type) {
        case GET_CASHBOX_CATEGORIES_API: {
            return {
                ...state,
                cashboxCategories: undefined,
                error: undefined
            }
        }
        case GET_CASHBOX_CATEGORIES_API_SUCCESS: {
            const successAction = action as GetCashboxCategoriesSuccessAction;

            return {
                ...state,
                cashboxCategories: parseDataKey(successAction.cashboxCategories),
            }
        }
        case GET_CASHBOX_CATEGORIES_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: CashboxErrorOrigin.GET_CASHBOX_CATEGORIES,
                    detail: errorAction.error
                }
            }
        }
        case UPSERT_CASHBOX_CATEGORY_API: {
            return {
                ...state,
                error: undefined,
                upsertCashboxCategorySuccess: false,
            }
        }
        case UPSERT_CASHBOX_CATEGORY_API_SUCCESS: {
            return {
                ...state,
                upsertCashboxCategorySuccess: true,
            }
        }
        case UPSERT_CASHBOX_CATEGORY_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: CashboxErrorOrigin.UPSERT_CASHBOX_CATEGORY,
                    detail: errorAction.error
                }
            }
        }
        case CREATE_INCOME_RECORD_API: {
            return {
                ...state,
                error: undefined,
                createIncomeRecordSuccess: false,
            }
        }
        case CREATE_INCOME_RECORD_API_SUCCESS: {
            return {
                ...state,
                createIncomeRecordSuccess: true,
            }
        }
        case CREATE_INCOME_RECORD_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: CashboxErrorOrigin.CREATE_INCOME_RECORD,
                    detail: errorAction.error
                }
            }
        }
        case GET_INCOME_RECORDS_API: {
            return {
                ...state,
                error: undefined,
                incomeRecords: undefined,
            }
        }
        case GET_INCOME_RECORDS_API_SUCCESS: {
            return {
                ...state,
                incomeRecords: parseDataKey(action.incomeRecords),
            }
        }
        case GET_INCOME_RECORDS_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: CashboxErrorOrigin.CREATE_INCOME_RECORD,
                    detail: errorAction.error
                }
            }
        }
    }
    return state;
};

export default cashboxReducer 